export enum AuthStatusEnum {
  WAITING_2FA = "WAITING_2FA",
  LOGGED_IN = "LOGGED_IN",
  LOGGED_OUT = "LOGGED_OUT",
}
